// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"16":"bf4ec45d","395":"6d042ac8"}[chunkId] + ".js";
};